import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import { getPlatformConfig } from '../../../constants/platformLogos';

const ActivityItem = ({ type, platform, content, timestamp, thumbnail, thumbnailAlt, engagement }) => {
  const getActivityIcon = () => {
    switch (type) {
      case 'post':
        return { name: 'FileText', color: 'text-accent', bg: 'bg-accent/10' };
      case 'comment':
        return { name: 'MessageSquare', color: 'text-primary', bg: 'bg-primary/10' };
      case 'engagement':
        return { name: 'Heart', color: 'text-error', bg: 'bg-error/10' };
      default:
        return { name: 'Activity', color: 'text-muted-foreground', bg: 'bg-muted' };
    }
  };

  const getPlatformLogo = () => {
    const platformKey = platform?.toLowerCase()?.replace(/\s+/g, '');
    const config = getPlatformConfig(platformKey);
    
    if (config) {
      return {
        logo: config?.logo,
        alt: config?.alt,
        color: config?.color
      };
    }
    
    return {
      logo: null,
      alt: 'Platform logo',
      color: '#6B7280'
    };
  };

  const activityIcon = getActivityIcon();
  const platformLogo = getPlatformLogo();

  return (
    <div className="flex gap-4 p-4 rounded-lg hover:bg-muted/50 transition-colors duration-150">
      <div className={`w-10 h-10 rounded-lg ${activityIcon?.bg} flex items-center justify-center flex-shrink-0`}>
        <Icon name={activityIcon?.name} size={20} className={activityIcon?.color} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1">
          {platformLogo?.logo ? (
            <div className="w-4 h-4 flex items-center justify-center">
              <Image 
                src={platformLogo?.logo}
                alt={platformLogo?.alt}
                className="w-full h-full object-contain"
                style={{ filter: `drop-shadow(0 0 1px ${platformLogo?.color}40)` }}
              />
            </div>
          ) : (
            <Icon name="Globe" size={16} className="text-muted-foreground" />
          )}
          <span className="text-sm font-medium text-foreground">{platform}</span>
          <span className="text-xs text-muted-foreground">{timestamp}</span>
        </div>
        <p className="text-sm text-foreground mb-2">{content}</p>
        {thumbnail && (
          <div className="w-full h-32 rounded-lg overflow-hidden bg-muted">
            <Image 
              src={thumbnail} 
              alt={thumbnailAlt}
              className="w-full h-full object-cover"
            />
          </div>
        )}
        {engagement && (
          <div className="flex items-center gap-4 mt-3 text-xs text-muted-foreground">
            <div className="flex items-center gap-1">
              <Icon name="Heart" size={14} />
              <span>{engagement?.likes}</span>
            </div>
            <div className="flex items-center gap-1">
              <Icon name="MessageCircle" size={14} />
              <span>{engagement?.comments}</span>
            </div>
            <div className="flex items-center gap-1">
              <Icon name="Share2" size={14} />
              <span>{engagement?.shares}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ActivityItem;